<template>
  <div id="app">
    <m-header></m-header>
    <!-- 导航-->
    <!-- 子路由的出口 -->
	<!-- <router-view  :key='$route.fullPath'></router-view> -->
	
   
   <!-- 这里是会被缓存的视图组件 -->
   <!-- :key='$route.fullPath'解决同一组件复用，不跳转页面 -->
  <keep-alive>
    <router-view v-if="$route.meta.keepAlive" :key='$route.fullPath'></router-view>
    </keep-alive>
    <!-- 这里是不被缓存的视图组件 -->
    <router-view v-if="!$route.meta.keepAlive" :key='$route.fullPath'></router-view>
	
	
	
     <nav-footer></nav-footer>
  </div>
</template>

<script>
import MHeader from '@/common/MHeader'
import NavFooter from '@/common/NavFooter'
export default {
  components:{
    MHeader,
    NavFooter,
  },
	data() {
		return{

		}
	},
  mounted() {
  },
 created(){


	},
	methods:{

	}

}
</script>

<style>

</style>
